"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function nearestMinutes(interval, someMoment) {
    const roundedMinutes = Math.round(someMoment.clone().minute() / interval) * interval;
    return someMoment
        .clone()
        .minute(roundedMinutes)
        .second(0);
}
exports.nearestMinutes = nearestMinutes;
function nearestPastMinutes(interval, someMoment) {
    const roundedMinutes = Math.floor(someMoment.minute() / interval) * interval;
    return someMoment
        .clone()
        .minute(roundedMinutes)
        .second(0);
}
exports.nearestPastMinutes = nearestPastMinutes;
function nearestFutureMinutes(interval, someMoment) {
    const roundedMinutes = Math.ceil(someMoment.minute() / interval) * interval;
    return someMoment
        .clone()
        .minute(roundedMinutes)
        .second(0);
}
exports.nearestFutureMinutes = nearestFutureMinutes;
//# sourceMappingURL=nearestMinutes.js.map